import { Component } from '../Component';
import swiperStyles from '../../../node_modules/swiper/swiper-bundle.min.css?inline';
import Swiper from 'swiper';
import { rosAnimation, STAnimationType } from '../../utils/ScrollTriggerHelper';
import { Power2 } from 'gsap';
import { ArgSpecDictionary } from '../ComponentUtils';

const DEBUG_VERBOSE: boolean = false;
export const HHDSCarouselTagName: string = 'hhds-carousel';
const TAG_NAME: string = HHDSCarouselTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export const HHDSCarouselAttrNames = {};

//const Attrs = HHDSCarouselAttrNames;

export class HHDSCarousel extends Component {
	private swiperContainer: HTMLElement | null = null;
	private swiperInstance: Swiper | null = null;
	private rosTweens: gsap.core.Tween[] = [];

	constructor() {
		super();
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');

		const html: string = `
			<div class="wrapper hhds-carousel-slider ${TAG_NAME}">
				<h2 class="heading heading--05 ${TAG_NAME}__heading">Gallery</h2>
        <slot class="slides"></slot>
				<div class="swiper">
					<div class="swiper-wrapper"></div>
				</div>
			</div>
    `;

		this.setInnerHtml('', '', html, [swiperStyles]);

		this.swiperContainer = this.root?.querySelector('.swiper') as HTMLElement;

		requestAnimationFrame(() => {
			this.initializeSwiper();
		});

		this.observeSlotChanges(true);
	}

	initializeSwiper() {
		if (!this.swiperContainer) throw new Error('No swiperContainer');

		this.swiperInstance = new Swiper(this.swiperContainer, {
			loop: false,
			slideFullyVisibleClass: 'swiper-slide-visible',
			slidesPerView: 1.05,
			spaceBetween: 16,
			speed: 300,
			breakpoints: {
				// when window width is >=
				375: {
					slidesPerView: 2.05,
					spaceBetween: 16,
				},
				834: {
					slidesPerView: 2.05,
					spaceBetween: 20,
				},
				// when window width is >=
				1500: {
					slidesPerView: 2.05,
					spaceBetween: 24,
				},
			},
			on: {
				init: () => {
					/*this.setButtonDisabledState();
          requestAnimationFrame(() => {
            this.handleVisibleSlides();
          });*/
				},
				slideChange: (_swiper: Swiper) => {
					/*this.setButtonDisabledState();
          this.handleVisibleSlides();
          DEBUG_VERBOSE && logger.log("slideChange", swiper);*/
				},
				resize: () => {
					//this.handleVisibleSlides();
				},
			},
		});

		this.swiperInstance.init();
		//this.checkNavVisibility(true);
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'destroy');
		this.rosTweens.forEach((tween) => tween.kill());
		this.rosTweens = [];
		this.swiperInstance?.destroy();
		this.swiperInstance = null;
	}

	override onAttributeChanged(name: string, _oldValue: string, _newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onAttributeChanged: ${name}`);
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, elements: HTMLElement[]): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onSlotChange`);
		if (elements.length == 0) return;

		this.initializeSwiper();

		const swiperWrapperSelector = '.swiper-wrapper';
		const swiperWrapper = this.root?.querySelector(swiperWrapperSelector);
		if (!swiperWrapper) throw new Error(`Unable to derive selector: ${swiperWrapperSelector}`);

		elements.forEach((element) => {
			element.classList.add('swiper-slide');
			swiperWrapper.appendChild(element);
		});

		let previousElementTween: gsap.core.Tween | null = null;
		elements.forEach((element, index) => {
			// Attempt to create a tween for the first element in the animation sequence.
			// If stAnimation returns null, either the reveal-on-scroll is disabled, or
			// the tween is a Triggered-type tween and the element is already past its startPercent
			// and will have been set to 100% progress. If the first element is at 100% progress, it
			// can look better to opt not to animate any of the remaining elements either, rendering
			// the entire sequence as already revealed.
			const startPercent = '30%'; // + (80 / elementCount) * index;
			if (previousElementTween || index == 0) {
				const tween = rosAnimation(element, STAnimationType.triggered, {
					easing: Power2.easeInOut,
					duration: 0.3,
					start: startPercent,
					end: '100%',
					startProps: { y: 30, autoAlpha: 0.0 },
					endProps: { y: 0, autoAlpha: 1.0 },
				});
				tween && this.rosTweens.push(tween);
				previousElementTween = tween;
			}
		});
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {};
